import React from 'react';
import styled from 'styled-components';

const BlogContainer = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 60px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 24px;
  color: #333;
  font-size: 2rem;
`;

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 600px; /* 高さは必要に応じて調整してください */
  overflow: hidden;
  border-radius: 8px;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none; /* iframeの枠線を消します */
`;

const BlogHighSchool = () => {
  const blogUrl = "https://www.daiichigakuin.ed.jp/campus/kochi/blog/archive/";

  return (
    <BlogContainer>
      <Title>第一学院高等学校 高知キャンパスブログ</Title>
      <IframeWrapper>
        <StyledIframe src={blogUrl} title="第一学院高等学校 高知キャンパス ブログ" />
      </IframeWrapper>
    </BlogContainer>
  );
};

export default BlogHighSchool;